module.exports = __webpack_public_path__ + "img/tab-create-inactive.2a5c4f0.png";